<mat-form-field class="autocomplete-field position-relative" [class.loading-field]="loading"
[ngClass]="{'ng-invalid': selectedMax && selectedList.length > selectedMax}">
  <mat-label>{{label}}</mat-label>

  <input #input type="text" matInput [formControl]="searchCtr" [matAutocomplete]="auto"
  (keydown.enter)="handleEnter(input.value, $event)" appConvertArabicNumbers [disabled]="disabled" [readonly]="disabled">

  <!-- 👇 This adds the arrow icon -->
  <button mat-icon-button matSuffix [disabled]="disabled" (click)="input.focus()">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
    <!-- Add Option -->
    <mat-option class="font-18 dark-green light-green-background" *ngIf="showAddOption && searchCtr.value"
      (mousedown)="prepareToAdd(input.value)" (click)="$event.stopPropagation(); onAddNewItem()">
      <img src="/assets/images/recuruitment/plus.svg" alt=""> {{ 'general.Add' | translate }}
    </mat-option>

    <mat-option *ngFor="let item of filteredList | async" [disabled]="true" [value]="item">
      <div (click)="$event.stopPropagation()">
        <mat-checkbox [checked]="isSelected(item)" (change)="selected(item)">
          {{ item.name }}
        </mat-checkbox>
      </div>
    </mat-option>
  </mat-autocomplete>

  <mat-error *ngIf="searchCtr.hasError('required')">
    {{ 'forms.Required' | translate }}
  </mat-error>
  <mat-hint class="pt-1 pb-2" *ngIf="!isRequired && !selectedMax">{{"general.optional"|translate}}</mat-hint>
</mat-form-field>

<div [ngClass]="{'mt-2': !isRequired && !selectedMax}">
  <ul class="chips-selected">
    <li *ngFor="let item of selectedList; index as index">
      <p>{{item.name}}</p>
      <span class="remove" *ngIf="!disabled" (click)="removeSelected(index)">&times;</span>
    </li>
  </ul>
  <p class="has-error mt-2" *ngIf="(selectedList.length > selectedMax) && isSubmitted">
    {{ 'posting.Maximum selection' | translate: {num: selectedMax} }}
  </p>
</div>